import { Component, Input, OnInit } from '@angular/core';
import { AddHomeScreenComponent } from '@components/master-layout/navs/components/add-home-screen/add-home-screen.component';
import { LanguagesComponent } from '@components/master-layout/navs/components/languages/languages.component';
import { AuthenService } from '@core/authen/authen.service';
import { ReportingPopupService } from '@core/services/reporting-popup.service';
import { SessionService } from '@core/session.service';
import { environment } from '@env/environment';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { matUploadFileRound } from '@ng-icons/material-icons/round';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateModule } from '@ngx-translate/core';
import { LanguagePathDirective } from '@shared/directives/language-path.directive';
import { RequireLoginDirective } from '@shared/directives/require-login.directive';
import { UnsavedFormCheckDirective } from '@shared/directives/unsaved-form-check.directive';
import { UrlPrefixDirective } from '@shared/directives/url-prefix.directive';
import { StorageEnum } from '@shared/enums/storage.enum';
import { NavInterface } from '@shared/interfaces/nav.interface';
import { UserInterface } from '@shared/interfaces/user.interface';
import { FormUtils } from '@shared/utils/form-utils';

@UntilDestroy()
@Component({
  selector: 'app-nav-information',
  templateUrl: './nav-information.component.html',
  imports: [
    NgIcon,
    TranslateModule,
    UnsavedFormCheckDirective,
    UrlPrefixDirective,
    LanguagePathDirective,
    RequireLoginDirective,
    LanguagesComponent,
    AddHomeScreenComponent,
  ],
  viewProviders: [provideIcons({ matUploadFileRound })],
})
export class NavInformationComponent implements OnInit {
  @Input() navigateUrl: string;

  @Input() isTenantAdmin: boolean;

  @Input() isStandaloneWidget = false;

  profileUrl = environment.jipUrl.profile;
  changePasswordUrl = environment.jipUrl.changePassword;
  changeEmailUrl = environment.jipUrl.changeEmail;
  adminSettingsUrl = environment.jipUrl.adminSettings;

  profile: UserInterface;

  navItem: NavInterface = {
    name: 'Login',
    jipIcon: 'navLogin',
    route: environment.jipUrl.profile,
  };
  tenantUrl: string;

  constructor(
    public authenService: AuthenService,
    public sessionService: SessionService,
    private readonly reportingPopupService: ReportingPopupService
  ) {}

  ngOnInit(): void {
    this.authenService.getProfile().subscribe(userProfile => {
      this.profile = userProfile;
    });

    this.sessionService.apiReady$
      .pipe(untilDestroyed(this))
      .subscribe(ready => {
        if (ready) {
          this.tenantUrl = this.sessionService.getTenantUrl();
        }
      });
  }

  logout(event): void {
    event.preventDefault();
    this.authenService.logout();
  }

  goToProfile(): void {
    if (this.sessionService.authenticated) {
      this.goTo(this.profileUrl);
    }
  }

  goTo(url): void {
    FormUtils.navigateTo(this.sessionService.appendLanguagePath(url));
  }

  openExportPopup(): void {
    this.reportingPopupService.openAdminReport();
  }

  storePreviousUrl(): void {
    localStorage.setItem(StorageEnum.previousUrl, globalThis.location.href);
  }

  goToLoginPage(): void {
    this.goTo(environment.jipUrl.login);
  }

  getCallBackLoginPage(): string {
    const isClientLandingPage = globalThis.location.href.includes(
      environment.jipUrl.clientLandingPage
    );
    const isTermOfUsePage = globalThis.location.href.includes(
      environment.jipUrl.termsOfUse
    );

    const currentLocale = this.sessionService
      .getCurrentLanguage()
      .locale.toLowerCase();

    const isHomePage =
      globalThis.location.pathname ===
      `/${currentLocale}${environment.jipUrl.home}`;

    if (isClientLandingPage || isTermOfUsePage || isHomePage) {
      return environment.jipUrl.news;
    }
  }
}
